module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputText fullname"
  }, [_c('v-text-field', {
    staticClass: "input-border-inset",
    attrs: {
      "label": _vm.label,
      "type": _vm.type,
      "value": _vm.value,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "hide-details": "",
      "single-line": ""
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d6b4c28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/InputText.vue
// module id = 1677
// module chunks = 8